/**
 * Generate names from formik object tree e.g. errors
 * @param {Object} obj object to
 * @returns {Array} array of strings
 */
export function errorToTouchedAndIds(obj) {
  const result = {};
  const errorIds = [];
  let objectsTodo = [
    {
      obj,
      parent: result,
      key: 'root',
      path: '',
    },
  ];

  while (objectsTodo.length) {
    const { obj: currentObj, parent, key, path } = objectsTodo.pop();
    if (Array.isArray(currentObj)) {
      parent[key] = [];
      const newParent = parent[key];
      const newTodos = currentObj.map((v, index) => ({
        obj: v,
        parent: newParent,
        key: index,
        path: `${path}[${index}]`,
      }));
      objectsTodo = objectsTodo.concat(newTodos);
    } else if (currentObj !== null && typeof currentObj === 'object') {
      parent[key] = {};
      const newParent = parent[key];
      const newTodos = Object.keys(currentObj).map((k) => ({
        obj: currentObj[k],
        parent: newParent,
        key: k,
        path: `${path}.${k}`,
      }));
      objectsTodo = objectsTodo.concat(newTodos);
    } else {
      parent[key] = true;
      errorIds.push(path.slice(1));
    }
  }
  return {
    touchedObj: result.root,
    errorIds,
  };
}

export default errorToTouchedAndIds;
